import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { usePartner } from '@shared/lib/partner';
import { getDescriptionByPartner } from '../lib/getDescriptionByPartner';
const Description: FC = () => {
  const {
    partner
  } = usePartner();
  const description = getDescriptionByPartner(partner);
  if (!description) return null;
  return <DescriptionWrapper>{description}</DescriptionWrapper>;
};
export default Description;
const DescriptionWrapper = /*#__PURE__*/styled('div')({
  name: "DescriptionWrapper",
  class: "d14spupo",
  propsAsIs: false
});

require("./Description.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Description.tsx");